import { useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

export function useLivros(userId) {
  const [livroAtual, setLivroAtual] = useState(null);
  const [livrosConcluidos, setLivrosConcluidos] = useState([]);
  const [loadingLivros, setLoadingLivros] = useState(false);

  const fetchLivros = useCallback(async () => {
    if (!userId) return;
    setLoadingLivros(true);
    const { data } = await supabase
      .from('user_livros')
      .select('*')
      .eq('user_id', userId);

    if (data) {
      setLivroAtual(data.find(l => l.status === 'lendo') || null);
      setLivrosConcluidos(data.filter(l => l.status === 'concluido'));
    }
    setLoadingLivros(false);
  }, [userId]);

  const getStatusLivro = useCallback((mes) => {
    if (livroAtual?.mes === mes) return 'lendo';
    if (livrosConcluidos.some(l => l.mes === mes)) return 'concluido';
    return 'nao_iniciado';
  }, [livroAtual, livrosConcluidos]);

  const iniciarLeitura = useCallback(async (livro) => {
    if (!userId) return;
    await supabase.from('user_livros').upsert(
      { user_id: userId, mes: livro.mes, titulo: livro.titulo, status: 'lendo' },
      { onConflict: 'user_id,mes' }
    );
    setLivroAtual({ mes: livro.mes, titulo: livro.titulo, status: 'lendo' });
  }, [userId]);

  const marcarComoLido = useCallback(async (livro) => {
    if (!userId) return;
    const data_conclusao = new Date().toISOString();
    await supabase.from('user_livros').upsert(
      { user_id: userId, mes: livro.mes, titulo: livro.titulo, status: 'concluido', data_conclusao },
      { onConflict: 'user_id,mes' }
    );
    setLivroAtual(null);
    setLivrosConcluidos(prev => [
      ...prev.filter(l => l.mes !== livro.mes),
      { mes: livro.mes, titulo: livro.titulo, status: 'concluido', data_conclusao },
    ]);
  }, [userId]);

  const stats = {
    livrosIniciados: livroAtual ? 1 : 0,
    livrosConcluidos: livrosConcluidos.length,
  };

  return {
    livroAtual,
    livrosConcluidos,
    stats,
    loadingLivros,
    fetchLivros,
    getStatusLivro,
    iniciarLeitura,
    marcarComoLido,
  };
}
